export const AUTH_FORM_COPY = {
    signin: {
        title: 'Welcome back',
        subtitle: 'Sign in to your account.',
        submitLabel: 'Sign In',
        switchPrompt: 'New to Dare Drop?',
        switchLabel: 'Sign up free',
        switchTo: 'signup',
        errorTitle: 'Could not sign in',
        errorFallback: 'Please check your email and password and try again.',
    },
    signup: {
        title: 'Create your account',
        subtitle: 'Start your journey with Dare Drop.',
        submitLabel: 'Create Account',
        switchPrompt: 'Already have an account?',
        switchLabel: 'Sign in',
        switchTo: 'signin',
        errorTitle: 'Could not sign up',
        errorFallback: 'Could not create your account. Please try again.',
    },
    forgot: {
        title: 'Reset password',
        subtitle: 'Enter your email and we will send a reset link.',
        submitLabel: 'Send reset link',
        switchPrompt: 'Remember your password?',
        switchLabel: 'Back to sign in',
        switchTo: 'signin',
        errorTitle: 'Could not send reset link',
        errorFallback: 'Could not send the reset link. Please try again.',
    },
    reset: {
        title: 'Create a new password',
        subtitle: 'Choose a new password for your account.',
        submitLabel: 'Create new password',
        switchPrompt: 'Remembered it after all?',
        switchLabel: 'Back to sign in',
        switchTo: 'signin',
        errorTitle: 'Could not reset password',
        errorFallback: 'Could not reset your password. The link may have expired, please request a new one.',
    },
    transfer: {
        title: 'Please change your password',
        subtitle: 'For security reasons, set a new password to continue.',
        submitLabel: 'Continue',
        errorTitle: 'Could not set password',
        errorFallback: 'Could not set your password. The link may have expired, please sign in again.',
    },
};
